import { render, staticRenderFns } from "./Additional.vue?vue&type=template&id=61a3431e&scoped=true&"
import script from "./Additional.vue?vue&type=script&lang=js&"
export * from "./Additional.vue?vue&type=script&lang=js&"
import style0 from "./Additional.vue?vue&type=style&index=0&id=61a3431e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a3431e",
  null
  
)

component.options.__file = "Additional.vue"
export default component.exports